/**
 * Normalize phone number for database operations
 * Removes the '+' prefix to match database storage format
 */
export function normalizePhoneNumber(phoneNumber: string): string {
  if (!phoneNumber) return phoneNumber;
  return phoneNumber.startsWith('+') ? phoneNumber.substring(1) : phoneNumber;
}

/**
 * Format phone number for WhatsApp API
 * Ensures the phone number has a '+' prefix for WhatsApp API calls
 */
export function formatPhoneForWhatsApp(phoneNumber: string): string {
  if (!phoneNumber) return phoneNumber;
  return phoneNumber.startsWith('+') ? phoneNumber : `+${phoneNumber}`;
}

/**
 * Validate phone number format
 */
export function isValidPhoneNumber(phoneNumber: string): boolean {
  if (!phoneNumber) return false;
  const cleaned = normalizePhoneNumber(phoneNumber);
  return /^\d{10,15}$/.test(cleaned);
}